import {useRef} from 'react';

export const useFormRef = () => {
  const formRef = useRef(null);

  const submit = () => {
    if (formRef.current) {
      // @ts-ignore
      formRef.current.dispatchEvent(new Event('submit', {cancelable: true}));
    }
  };

  return {formRef, submit};
};
